const scheduledServicesOutput = {
  title: `Servicios a Realizar`,
  title1: `Servicios Vencidos`
};

export default scheduledServicesOutput;
